export default "__VITE_ASSET__Cu6FgeSr__"